import React, {useState, useEffect} from 'react';
import { createRoot } from 'react-dom/client';
import * as bootstrap from "bootstrap";
import PlacnikContainer from "./PlacnikContainer";

const phpData = window.dostava;
const countries = {
    "AF": "Afganistan",
    "AX": "Alandski otoki",
    "AL": "Albanija",
    "DZ": "Alžirija",
    "AS": "Ameriška Samoa",
    "AD": "Andora",
    "AO": "Angola",
    "AI": "Angvila",
    "AQ": "Antarktika",
    "AG": "Antigva in Barbuda",
    "AR": "Argentina",
    "AM": "Armenija",
    "AW": "Aruba",
    "AU": "Avstralija",
    "AT": "Avstrija",
    "AZ": "Azerbajdžan",
    "BS": "Bahami",
    "BH": "Bahrajn",
    "BD": "Bangladeš",
    "BB": "Barbados",
    "PW": "Belau",
    "BE": "Belgija",
    "BZ": "Belize",
    "BY": "Belorusija",
    "BJ": "Benin",
    "BM": "Bermudi",
    "BW": "Bocvana",
    "BG": "Bolgarija",
    "BO": "Bolivija",
    "BQ": "Bonaire, Saint Eustatius in Saba",
    "BA": "Bosna in Hercegovina",
    "CX": "Božični otok",
    "BR": "Brazilija",
    "VG": "Britanski Deviški otoki",
    "IO": "Britansko ozemlje v Indijskem oceanu",
    "BN": "Brunej",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "BT": "Butan",
    "TD": "Čad",
    "CZ": "Češka Republika",
    "CL": "Čile",
    "CY": "Ciper",
    "CK": "Cookovi otoki",
    "ME": "Črna Gora",
    "CW": "Curacao",
    "DK": "Danska",
    "VI": "Deviški otoki Združenih držav",
    "DJ": "Djibouti",
    "DM": "Dominika",
    "DO": "Dominikanska republika",
    "EG": "Egipt",
    "EC": "Ekvador",
    "GQ": "Ekvatorijalna Gvineja",
    "ER": "Eritreja",
    "EE": "Estonija",
    "ET": "Etiopija",
    "FK": "Falklandski Otoki",
    "FO": "Ferski Otoki",
    "FJ": "Fidži",
    "PH": "Filipini",
    "FI": "Finska",
    "FR": "Francija",
    "GF": "Francoska Gvajana",
    "PF": "Francoska Polinezija",
    "TF": "Francoska južna in antarktična ozemlja",
    "GA": "Gabon",
    "GM": "Gambija",
    "GH": "Gana",
    "GI": "Gibraltar",
    "GR": "Grčija",
    "GD": "Grenada",
    "GL": "Grenlandija",
    "GE": "Gruzija",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GG": "Guernsey",
    "GY": "Gvajana",
    "GT": "Gvatemala",
    "GN": "Gvineja",
    "GW": "Gvineja-Bissau",
    "HT": "Haiti",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HR": "Hrvaška",
    "IN": "Indija",
    "ID": "Indonezija",
    "IQ": "Irak",
    "IR": "Iran",
    "IE": "Irska",
    "IS": "Islandija",
    "IT": "Italija",
    "IL": "Izrael",
    "JM": "Jamajka",
    "JP": "Japonska",
    "YE": "Jemen",
    "JE": "Jersey",
    "JO": "Jordanija",
    "ZA": "Južna Afrika",
    "GS": "Južna Georgia in Južni Sandwichevi otoki",
    "KR": "Južna Koreja",
    "SS": "Južni Sudan",
    "KY": "Kajmanski Otoki",
    "KH": "Kambodža",
    "CM": "Kamerun",
    "CA": "Kanada",
    "QA": "Katar",
    "KZ": "Kazahstan",
    "KE": "Kenija",
    "KG": "Kirgizistan",
    "KI": "Kiribati",
    "CN": "Kitajska",
    "CC": "Kokosovi otoki",
    "CO": "Kolumbija",
    "KM": "Komori",
    "CG": "Kongo (Brazzaville)",
    "CD": "Kongo (Kinšasa)",
    "CR": "Kostarika",
    "CU": "Kuba",
    "KW": "Kuvajt",
    "LA": "Laos",
    "LV": "Latvija",
    "LS": "Lesoto",
    "LB": "Libanon",
    "LR": "Liberija",
    "LY": "Libija",
    "LI": "Liechtenstein",
    "LT": "Litva",
    "LU": "Luksemburg",
    "MO": "Macao",
    "MG": "Madagaskar",
    "HU": "Madžarska",
    "MW": "Malavi",
    "MV": "Maldivi",
    "MY": "Malezija",
    "ML": "Mali",
    "MT": "Malta",
    "UM": "Manjši zunanji otoki Združenih Držav Amerike",
    "MA": "Maroko",
    "MH": "Marshallovi otoki",
    "MQ": "Martinik",
    "MR": "Mavretanija",
    "MU": "Mavricij",
    "YT": "Mayotte",
    "MX": "Mehika",
    "FM": "Mikronezija",
    "MM": "Mjanmar",
    "MD": "Moldavija",
    "MC": "Monako",
    "MN": "Mongolija",
    "MS": "Montserrat",
    "MZ": "Mozambik",
    "NA": "Namibija",
    "NR": "Nauru",
    "DE": "Nemčija",
    "NP": "Nepal",
    "NE": "Niger",
    "NG": "Nigerija",
    "NI": "Nikaragva",
    "NU": "Niue",
    "NL": "Nizozemska",
    "NF": "Norfolški otok",
    "NO": "Norveška",
    "NC": "Nova Kaledonija",
    "NZ": "Nova Zelandija",
    "OM": "Oman",
    "BV": "Otok Bouvet",
    "HM": "Otok Heard in otočje McDonald",
    "IM": "Otok Man",
    "TC": "Otoki Turks in Caicos",
    "PS": "Ozemlje Palestine",
    "PK": "Pakistan",
    "PA": "Panama",
    "PG": "Papua Nova Gvineja",
    "PY": "Paragvaj",
    "PE": "Peru",
    "PN": "Pitcairnovi otoki",
    "PL": "Poljska",
    "PR": "Portoriko",
    "PT": "Portugalska",
    "RE": "Reunion",
    "RO": "Romunija",
    "RW": "Ruanda",
    "RU": "Rusija",
    "PM": "Saint Pierre in Miquelon",
    "SB": "Salomonovi Otoki",
    "SV": "Salvador",
    "WS": "Samoa",
    "SM": "San Marino",
    "SA": "Savdska Arabija",
    "SC": "Sejšeli",
    "SN": "Senegal",
    "KP": "Severna Koreja",
    "MK": "Severna Makedonija",
    "MP": "Severni Marijanski otoki",
    "SL": "Sierra Leone",
    "SG": "Singapur",
    "SY": "Sirija",
    "CI": "Slonokoščena obala",
    "SK": "Slovaška",
    "SI": "Slovenija",
    "SO": "Somalija",
    "ES": "Španija",
    "RS": "Srbija",
    "CF": "Srednjeafriška republika",
    "LK": "Šrilanka",
    "SD": "Sudan",
    "SR": "Surinam",
    "SJ": "Svalbard in Jan Mayen",
    "SZ": "Svazi",
    "SE": "Švedska",
    "SH": "Sveta Helena",
    "LC": "Sveta Lucija",
    "BL": "Sveti Bartolomej",
    "KN": "Sveti Krištof in Nevis",
    "MF": "Sveti Martin (francoski del)",
    "SX": "Sveti Martin (nizozemski del)",
    "ST": "Sveti Tomaž in Princ",
    "VC": "Sveti Vincencij in Grenadine",
    "CH": "Švica",
    "TJ": "Tadžikistan",
    "TH": "Tajska",
    "TW": "Tajvan",
    "TZ": "Tanzanija",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad in Tobago",
    "TN": "Tunizija",
    "TR": "Turčija",
    "TM": "Turkmenistan",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukrajina",
    "UY": "Urugvaj",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VA": "Vatikan",
    "GB": "Velika Britanija (UK)",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "TL": "Vzhodni Timor",
    "WF": "Wallis in Futuna",
    "EH": "Zahodna Sahara",
    "ZM": "Zambija",
    "US": "Združene Države Amerike (ZDA)",
    "AE": "Združeni arabski emirati",
    "CV": "Zelenortski otoki",
    "ZW": "Zimbabve"
};


function AddAddressModal({ onSaved }) {
    const [form, setForm] = React.useState({
        company: "",
        address_1: "",
        city: "",
        postcode: "",
        country: "SI", // default
        state: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!form.address_1 || !form.city || !form.postcode) {
            alert("Prosim, izpolnite vse obvezne podatke.");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("action", "save_shipping_address");
            formData.append("nonce", phpData.nonce); // from wp_localize_script

            // append all form fields
            Object.entries(form).forEach(([key, value]) => {
                formData.append(key, value);
            });

            const res = await fetch(phpData.ajax_url, {
                method: "POST",
                credentials: "same-origin",
                body: formData
            });

            const data = await res.json();

            if (!data.success) {
                alert(data.data?.message || "Napaka pri shranjevanju naslova");
                return;
            }

            // call callback to update parent state
            if (onSaved) onSaved(data.data.address);

            // close bootstrap modal
            const modalEl = document.getElementById("addAddressModal");
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) modalInstance.hide();

            // reset form
        setForm({
                company: "",
                address_1: "",
                city: "",
                postcode: "",
                country: "SI",
                state: ""
        });
        } catch (err) {
            console.error(err);
            alert("Prišlo je do napake.");
        }
    };

    return (
        <div
            className="modal fade"
            id="addAddressModal"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">Dostavi na drug naslov?</h3>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    <div className="modal-body">
                        {/* Company */}
                        <div className="mb-3">
                            <label className="form-label">Naziv podjetja</label>
                            <input
                                className="form-control"
                                name="company"
                                   value={form.company}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Address */}
                        <div className="mb-3">
                            <label className="form-label">Ulica</label>
                            <input
                                className="form-control"
                                name="address_1"
                                value={form.address_1}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Postcode & City */}
                        <div className="row g-0">
                            <div className="col-md-6 mb-3 mr-1">
                                <label className="form-label">Poštna št</label>
                                <input
                                    className="form-control"
                                    name="postcode"
                                    value={form.postcode}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3 ml-1">
                                <label className="form-label">Mesto </label>
                                <input
                                    className="form-control"
                                    name="city"
                                    value={form.city}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        {/* Country */}
                        <div className="mb-3">
                            <label className="form-label">Država</label>
                            <select
                                name="country"
                                className="form-select country_to_state country_select"
                                autoComplete="country"
                                value={form.country}
                                onChange={handleChange}
                            >
                                <option value="">Izberi državo / regijo…</option>
                                <option value="AU">Avstralija</option>
                                <option value="HR">Hrvaška</option>
                                <option value="SI">Slovenija</option>
                            </select>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Prekliči
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                        >
                            Dodaj
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function DostavaContainer(props) {

    const [shippingLocations, setShippingLocations] = useState(
        Object.values(phpData.shipping)
    ); // array lokacij

    const [selectedLocationID, setSelectedLocationID] = useState(
        shippingLocations[0]?.LocationID ?? null
    );

    useEffect(() => {
        if (!selectedLocationID && shippingLocations.length > 0) {
            setSelectedLocationID(shippingLocations[0].LocationID);
        }
    }, [shippingLocations]);

    const handleChange = (e) => {
        setSelectedLocationID(e.target.value);
    };

    const handleSaved = (newAddress) => {
        setShippingLocations((prev) => [...prev, newAddress]);
        setSelectedLocationID(newAddress.LocationID);
    };

    const selectedLocation =
        selectedLocationID && selectedLocationID !== "new"
            ? shippingLocations.find(
            loc => loc.LocationID === selectedLocationID
        ) ?? null
            : null;

    const handleAddNew = () => {
        // setSelectedLocationID("new"); // highlight card
        const modalEl = document.getElementById("addAddressModal");
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
    };


    return (
        <>
            {selectedLocation && (
                <>
                    <input type="hidden" name="shipping_company" value={selectedLocation.company || ""} />
                    <input type="hidden" name="shipping_address_1" value={selectedLocation.address_1 || ""} />
                    <input type="hidden" name="shipping_city" value={selectedLocation.city || ""} />
                    <input type="hidden" name="shipping_postcode" value={selectedLocation.postcode || ""} />
                    <input type="hidden" name="shipping_country" value={selectedLocation.country || ""} />
                </>
            )}
            <div className="row g-0">
                {shippingLocations.map((option) => (
                    <div className="col-md-6 mb-3 p-0" key={option.LocationID}>
                        <div
                            className={`card h-100 mx-2 ${
                                selectedLocationID === option.LocationID
                                    ? "border-primary shadow bg-primary text-white"
                                    : "border"
                                }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedLocationID(option.LocationID)}
                        >
                            <div className="card-body">
                                <h5 className="card-title p-0">{option.company}</h5>
                                <p className="card-text m-0">{option.first_name} {option.last_name}</p>
                                <p className="card-text m-0">{option.address_1}</p>
                                <p className="card-text m-0">{option.postcode} {option.city}</p>
                                <p className="card-text m-0">{countries[option.country]}</p>
                                <p className="card-text m-0">{option.order_comments}</p>
                            </div>
                        </div>
                    </div>
                ))}

                {/* ADD NEW CARD */}
                <div className="col-md-6 mb-3 p-0">
                    <div
                        className={`card h-100 mx-2 d-flex align-items-center justify-content-center ${
                            selectedLocationID === "new"
                                ? "border-primary shadow"
                                : "border border-dashed"
                            }`}
                        style={{ cursor: "pointer" }}
                        onClick={handleAddNew}
                    >
                        <div className="card-body text-center">
                            <svg
                                width={50}
                                height={50}
                                viewBox="0 0 32 32"
                                fill="#59a5c3"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path d="M27.2,8.22H23.78V5.42A3.42,3.42,0,0,0,20.36,2H5.42A3.42,3.42,0,0,0,2,5.42V20.36a3.42,3.42,0,0,0,3.42,3.42h2.8V27.2A2.81,2.81,0,0,0,11,30H27.2A2.81,2.81,0,0,0,30,27.2V11A2.81,2.81,0,0,0,27.2,8.22ZM5.42,21.91a1.55,1.55,0,0,1-1.55-1.55V5.42A1.54,1.54,0,0,1,5.42,3.87H20.36a1.55,1.55,0,0,1,1.55,1.55v2.8H11A2.81,2.81,0,0,0,8.22,11V21.91ZM28.13,27.2a.93.93,0,0,1-.93.93H11a.93.93,0,0,1-.93-.93V11a.93.93,0,0,1,.93-.93H27.2a.93.93,0,0,1,.93.93Z" />
                                <path d="M24.09,18.18H20v-4a.93.93,0,1,0-1.86,0v4h-4a.93.93,0,0,0,0,1.86h4v4.05a.93.93,0,1,0,1.86,0V20h4.05a.93.93,0,1,0,0-1.86Z" />
                            </svg>

                            <h5 className="card-title p-0 m-0">{selectedLocation ?  "Dostavi na drug naslov?" : "Dodaj dostavni naslov."}</h5>
                            <p className="card-text text-muted m-0">
                                Dodaj naslov za dostavo.
                            </p>
                        </div>
                    </div>
                </div>

            </div>

            <AddAddressModal onSaved={handleSaved} />
        </>
    );
}

let container =  document.getElementById('ekoda-shipping');
// console.log(container);
// console.log("Tukaj sem :D");

if(container) {
    const root = createRoot(container);
    root.render(
        <DostavaContainer />
    );
}



